import React from 'react';
interface ProgressIndicatorProps {
  total: number;
  current: number;
}
export function ProgressIndicator({
  total,
  current
}: ProgressIndicatorProps) {
  return <div className="flex items-center justify-center space-x-3 py-6" aria-label={`Slide ${current} of ${total}`} data-id="element-40">
      {Array.from({
      length: total
    }).map((_, index) => {
      const isActive = index + 1 === current;
      return <div key={index} className={`rounded-full transition-all duration-300 ease-in-out ${isActive ? 'w-3 h-3 bg-solventum-primary' : 'w-2 h-2 bg-white/30'}`} aria-current={isActive ? 'step' : undefined} data-id="element-41" />;
    })}
    </div>;
}